export const showDidomiConsentModal = () => {
    if ("Didomi" in window && typeof window.Didomi === "object") {
        window.Didomi.preferences.show();
    }
};
